export default __webpack_public_path__ + "static/media/offerta.9ec5d364.svg";